<div class="license-expired-container">
  <div class="content-wrapper">
    <!-- Header con logo/icono -->
    <div class="header-section">
      <div class="icon-container">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <h1 class="main-title">Plan Finalizado</h1>
    </div>

    <!-- Mensaje principal -->
    <div class="message-section">
      <h2 class="subtitle">Su suscripción de plataforma ha vencido</h2>
      <p class="description">
        Para continuar utilizando nuestros servicios, por favor póngase en
        contacto con nuestro equipo de administración.
      </p>
      <p class="waiting-message">
        Estaremos atentos a su regreso. Siempre será bienvenido.
      </p>
    </div>

    <!-- Información de contacto -->
    <div class="contact-section">
      <div class="contact-card">
        <div class="contact-item">
          <i class="pi pi-phone"></i>
          <span>978726211</span>
        </div>
        <div class="contact-item">
          <i class="pi pi-envelope"></i>
          <span>administracion@gltracker.pe</span>
        </div>
        <div class="contact-item">
          <i class="pi pi-clock"></i>
          <span>Lun - Vie: 8:00 AM - 6:00 PM</span>
        </div>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="actions-section">
      <a
        class="btn btn-primary"
        href="https://api.whatsapp.com/send?phone=51978726211&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20GLtracker"
        target="_blank"
      >
        <i class="pi pi-phone"></i>
        Contactar administración
      </a>
      <button class="btn btn-secondary" (click)="redirectToLogin()">
        <i class="pi pi-home"></i>
        Ir al inicio
      </button>
    </div>

    <!-- Ilustración de vehículos -->
    <div class="illustration-section">
      <div class="vehicle-icons">
        <div class="vehicle-item">
          <i>
            <svg width="32" height="32" fill="currentColor">
              <use xlink:href="./assets/icons/license.svg#car"></use>
            </svg>
          </i>
        </div>
        <div class="vehicle-item">
          <i>
            <svg width="32" height="32" fill="currentColor">
              <use xlink:href="./assets/icons/license.svg#boat"></use>
            </svg>
          </i>
        </div>
        <div class="vehicle-item">
          <i>
            <svg width="32" height="32" fill="currentColor">
              <use xlink:href="./assets/icons/license.svg#bus"></use>
            </svg>
          </i>
        </div>
      </div>
      <div class="tracking-line"></div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer-section">
    <p>&copy; TODOS LOS DERECHOS RESERVADOS - GL TRACKER {{ currentYear }}</p>
  </div>
</div>
